import { MenuCategoryMapping } from './constants';

export const getMenuByGoalCategory = (searchChild) => {
  const category = Object.keys(MenuCategoryMapping).find(key =>
    MenuCategoryMapping[key].includes(searchChild));
  return category;
};
